import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { communityUrl, money } from "@/lib/api";

const COLORS = { verified: "#03A896", researched: "#4D8A2A", listing: "#0B2150", pending: "#2563EB" };

const FitBounds = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) { map.setView([points[0].latitude, points[0].longitude], 14); return; }
    map.fitBounds(points.map((p) => [p.latitude, p.longitude]), { padding: [30, 30], maxZoom: 13 });
  }, [points, map]);
  return null;
};

export const MapView = ({ points = [], height = "100%", zoom = 4, testid = "map-view" }) => (
  <div style={{ height }} className="w-full rounded-2xl overflow-hidden border border-[#E2E8F0]" data-testid={testid}>
    <MapContainer center={[38.5, -96]} zoom={zoom} preferCanvas scrollWheelZoom className="h-full w-full" aria-label="Map of HOA communities">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <FitBounds points={points} />
      {points.map((p) => (
        <CircleMarker key={p.id} center={[p.latitude, p.longitude]} radius={p.status === "researched" || p.status === "verified" ? 9 : 6}
          pathOptions={{ color: "#fff", weight: 1.5, fillColor: COLORS[p.status] || "#0B2150", fillOpacity: 0.9 }}>
          <Popup>
            <div className="space-y-1 min-w-[160px]">
              <p className="font-semibold text-[#0B2150] text-sm m-0">{p.name}</p>
              <p className="text-xs text-slate-600 m-0">{p.city}, {p.state_code}</p>
              <p className="text-sm font-bold text-[#027A6D] m-0">{p.fee_estimated && "Est. "}{money(p.monthly_fee)}<span className="text-xs font-normal">/mo</span></p>
              <Link to={communityUrl(p)} className="text-xs font-semibold text-[#027A6D] underline">View HOA details</Link>
            </div>
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  </div>
);
